import { motion } from "framer-motion";
import * as React from "react";
const PlacementCard = ({ student, isNonTech }) => (
  <motion.div
    className={`flex-shrink-0 mx-2 bg-white rounded-lg shadow-md px-4 py-2  hover:shadow-lg transition-all `}
    whileHover={{ scale: 1.02, y: -2 }}
  >
    <div className="flex items-center gap-3">
      <div className="relative">
        <img
          src={student.image}
          alt={student.name}
          className={`w-14 h-14 rounded-full object-cover`}
        />
        {isNonTech && (
          <div className="absolute -top-1 -right-1 w-4 h-4 bg-[#127971] rounded-full flex items-center justify-center">
            <span className="text-white text-[8px] font-bold">NT</span>
          </div>
        )}
      </div>
      <div className="flex items-center gap-3 min-w-0">
        <div className="min-w-0">
          <h3 className="font-semibold text-md text-gray-800 truncate">
            {student.name}
          </h3>
          <p className="text-sm text-gray-500 truncate">{student.role}</p>
        </div>
        <div className="flex items-center gap-2 text-sm whitespace-nowrap">
          <span className="text-gray-600 truncate max-w-[120px]">
            {student.company}
          </span>
          <span className="text-gray-400">•</span>
          <span className="font-bold text-[#26BDB0] text-sm">{student.package}</span>
        </div>
      </div>
    </div>
  </motion.div>
);

export default PlacementCard;
